import { useLocation, useNavigate } from 'react-router';
import { Event } from '../types/event.types';
import { FamilyMember } from '../types/family.types';

interface UseEventNavigationReturn {
  selectedEvent: Event | null;
  returnTo: string;
  navigateNext: (selectedMembers: string[], memberDetails: FamilyMember[]) => void;
}

export const useEventNavigation = (): UseEventNavigationReturn => {
  const location = useLocation();
  const navigate = useNavigate();

  const selectedEvent: Event | null = location.state?.selectedEvent || null;
  const returnTo: string = location.state?.returnTo || '/events';

  const navigateNext = (selectedMembers: string[], memberDetails: FamilyMember[]) => {
    if (selectedMembers.length === 0) return;

    if (selectedEvent) {
      navigate('/check-in-confirmation', {
        state: {
          event: selectedEvent,
          selectedMembers,
          memberDetails,
        },
      });
    } else {
      navigate('/events', {
        state: {
          selectedMembers,
          memberDetails,
        },
      });
    }
  };

  return {
    selectedEvent,
    returnTo,
    navigateNext,
  };
};
